// Styled component which serves as spacer for either a vertical or horizontal
// direction.

import styled from 'styled-components'

// the props are optional
export const RowSpacer = styled.div<{ space: string }>`
  width: ${(props) => props.space};
`

export const ColumnSpacer = styled.div<{ space: string }>`
  height: ${(props) => props.space};
`
